"use client";
import { Button } from "@/components-shared/ui/button";
import { cn } from "@/lib/utils";
import { toggleDrawer } from "@/redux/slices/drawer.slice";
import { RootState } from "@/redux/store";
import React, { MouseEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChatIcon } from "./icons";
import { toast } from "sonner";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

const ChatBtn = ({
  unitId,
  ownerCode,
}: {
  unitId: string;
  ownerCode: string;
}) => {
  const { isLoggedIn } = useSelector((state: RootState) => state.login);
  const userData = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const router = useRouter();
  const t = useTranslations();

  const goToChat = async (e: MouseEvent) => {
    e.stopPropagation();
    if (!isLoggedIn) dispatch(toggleDrawer({ isOpen: true }));
    else if (Number(userData?.code) === Number(ownerCode)) {
      toast.error(t("error.cantChatWithOwner"));
    } else {
      router.push(`/all-units/${unitId}/chat-with-owner`);
    }
  };
  return (
    <Button
      className={cn("bg-black/50 rounded-full size-7 p-0.5")}
      onClick={(e) => goToChat(e)}
      size={"icon"}
      aria-label="chat button"
    >
      <ChatIcon className="*:!fill-white" />
    </Button>
  );
};

export default ChatBtn;
